import { render, staticRenderFns } from "./ResumeTemplate.vue?vue&type=template&id=04733ed3"
import script from "./ResumeTemplate.vue?vue&type=script&lang=js"
export * from "./ResumeTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports